import * as c from "react";
import { i as l, E as d, x as p, d as h, c as b } from "../createReactComponent-58f9bea8.mjs";
import { r as m } from "../state-7560d4dc.mjs";
import "../property-9daa16cd.mjs";
const v = l`
  :host {
    --exo-component-tab-gap: var(--exo-spacing-2x-small);
  }

  :host #tabs {
    display: flex;
    flex-wrap: nowrap;
    gap: var(--exo-component-tab-gap);
    padding-top: var(--exo-spacing-3x-small);
  }
`;
var x = Object.defineProperty;
class i extends d {
  constructor() {
    super(), this.selectedIndex = 0, this.mutationObserver = null, this.handleMutation = (e) => {
      e.forEach((t) => {
        t.type === "childList" && this.addEventListenersToTabItems();
      });
    }, this.mutationObserver = new MutationObserver(this.handleMutation);
  }
  connectedCallback() {
    super.connectedCallback(), this.initTabSelection(), this.addEventListenersToTabItems(), this.mutationObserver && this.mutationObserver.observe(this, { childList: !0 });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.mutationObserver && this.mutationObserver.disconnect();
  }
  initTabSelection() {
    const e = this.querySelector("ex-tab-item[selected]");
    e && (this.selectedIndex = Array.prototype.indexOf.call(this.children, e));
  }
  onKeypressHandler(e, t) {
    e.code === "Enter" && this.onSelectionUpdate(t);
  }
  onSelectionUpdate(e) {
    Array.prototype.slice.call(this.children).forEach((t, s) => {
      s === e ? (this.selectedIndex = s, t == null || t.setAttribute("selected", ""), this.dispatchCustomEvent("onSelect", { selectedIndex: s })) : t == null || t.removeAttribute("selected");
    });
  }
  addEventListenersToTabItems() {
    for (let e = 0; e < this.children.length; e += 1) {
      const t = this.children[e];
      t instanceof HTMLElement && (t.addEventListener("click", () => this.onSelectionUpdate(e)), t.addEventListener("keypress", (s) => this.onKeypressHandler(s, e)));
    }
  }
  render() {
    return p`
      <div id="tabs" role="tab">
        <slot></slot>
      </div>
    `;
  }
}
i.styles = v, ((a, e, t, s) => {
  for (var r, n = void 0, o = a.length - 1; o >= 0; o--)
    (r = a[o]) && (n = r(e, t, n) || n);
  n && x(e, t, n);
})([m()], i.prototype, "selectedIndex");
const u = h("ex-tab", i), g = b({ tagName: "ex-tab", elementClass: i, react: c, events: { onSelect: "onSelect" }, displayName: "ExTab", registerWebComponent: u });
export {
  g as ExTab,
  u as register
};
